import APIService from '../../../Services/APIService';
import { Apis } from '../../../Services/app.constants';
import {
  normalizeFeatureList,
  normalizeProfileList,
} from '../utils/normalizeLicense';

function extractList(data) {
  if (Array.isArray(data)) return data;
  return data?.list ?? data?.results ?? [];
}

/**
 * Pure Data Access Layer for License Management.
 */
export const licenseService = {
  async getLicenses(filters = {}) {
    const params = new URLSearchParams();
    if (filters.search) params.set('search', filters.search);

    const query = params.toString();
    const url = query ? `${Apis.licenseList}?${query}` : Apis.licenseList;
    return APIService.get(url);
  },

  async createLicense(payload) {
    return APIService.post(Apis.licenseDetail, payload);
  },

  async updateLicense(id, payload) {
    return APIService.patch(`${Apis.licenseDetail}${id}/`, payload);
  },

  async archiveLicense(id) {
    return APIService.remove(`${Apis.licenseDetail}${id}/`);
  },

  async getLicense(id) {
    return APIService.get(`${Apis.licenseDetail}${id}/`);
  },

  async getLicenseProfiles() {
    const res = await APIService.get(Apis.licenseProfiles);
    if (res?.status === 200 || res?.status === 201) {
      return {
        ...res,
        data: normalizeProfileList(extractList(res.data)),
      };
    }
    return res;
  },

  async getLicenseFeatures() {
    const res = await APIService.get(Apis.licenseFeatures);
    if (res?.status === 200 || res?.status === 201) {
      return {
        ...res,
        data: normalizeFeatureList(extractList(res.data)),
      };
    }
    return res;
  },
};
